export default "__VITE_ASSET__23006a8b__"